import { render, staticRenderFns } from "./LandingStatCard.vue?vue&type=template&id=e66748e4&scoped=true&"
import script from "./LandingStatCard.vue?vue&type=script&lang=js&"
export * from "./LandingStatCard.vue?vue&type=script&lang=js&"
import style0 from "./LandingStatCard.vue?vue&type=style&index=0&id=e66748e4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e66748e4",
  null
  
)

export default component.exports